import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../ui/select";

export const currentDubaiMonth = () => {
  const p = new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Dubai", year: "numeric", month: "2-digit" }).formatToParts(new Date());
  return `${p.find((x) => x.type === "year").value}-${p.find((x) => x.type === "month").value}`;
};

const label = (m) => new Date(`${m}-01T00:00:00`).toLocaleDateString("en-GB", { month: "short", year: "numeric" });

export const MonthSelect = ({ value, onChange, brand, status, allLabel = "All", testId }) => {
  const cur = currentDubaiMonth();
  const { data } = useQuery({
    queryKey: ["social-months", brand, status],
    queryFn: async () => (await api.get("/social/months", {
      params: { brand: brand === "all" ? undefined : brand, status: status === "all" ? undefined : status },
    })).data,
  });
  const months = data?.months || [];
  const count = (m) => months.find((x) => x.month === m)?.count || 0;
  const others = months.filter((m) => m.month !== cur);
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="h-8 w-[170px]" data-testid={testId}><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value={cur}>This month ({count(cur)})</SelectItem>
        {others.map((m) => <SelectItem key={m.month} value={m.month}>{label(m.month)} ({m.count})</SelectItem>)}
        <SelectItem value="all">{allLabel} ({data?.total ?? 0})</SelectItem>
      </SelectContent>
    </Select>
  );
};
